export function mergeAndFormatPromptConfig(source, target) {
  const updatedFeatures = target.map((feature, index) => ({
    ...feature,
    icon: source?.icons[index]
  }));

  return updatedFeatures;
}
